import { useTranslation } from "react-i18next";
import { PopupMainContent } from "../../components/Popup/Components";
import { uid } from "../../helper";
import moment from "jalali-moment";
import { DetailsInfoCard, DetailsInfoRow } from "../../components/Table/Components";
import { useApp } from "../../hooks/useApp";
import { Amount } from "../../components/General/Amount";
import { PaymentStatus } from "./PaymentStatus";

export const DebitPaymentView = ({data}) => {
    const {t} = useTranslation();
    const {paymentGateways} = useApp();
    
    return (
        <PopupMainContent $maxWidth="700px">
            <DetailsInfoCard style={{ margin: 0 }}>
                <DetailsInfoRow>
                    <b>{t("Account Number")}</b> <span><b>{uid(data.uid)}</b></span>
                </DetailsInfoRow>
                <DetailsInfoRow>
                    <b>{t("Invoice Number")}</b> <span>{data.order.order_id}</span>
                </DetailsInfoRow>
                <DetailsInfoRow>
                    <b>{t("Method")}</b> <span><b>{paymentGateways?.[data.payment_gateway]}</b></span>
                </DetailsInfoRow>
                <DetailsInfoRow>
                    <b>{t("Date")}</b> <span>{moment(data.created_at).format("D MMMM YYYY")}</span>
                </DetailsInfoRow>
                <DetailsInfoRow>
                    <b>{t("Time")}</b> <span>{moment(data.created_at).format("HH:mm:ss")}</span>
                </DetailsInfoRow>
                <DetailsInfoRow>
                    <b>{t("Amount")}</b> <span><Amount currency={data.order.currency} amount={data.order.price} /></span>
                </DetailsInfoRow>
                <DetailsInfoRow>
                    <b>{t("Plan")}</b> <span>{data.order.plan.name?.['en']}</span>
                </DetailsInfoRow>
                <DetailsInfoRow>
                    <b>{t("Transaction ID")}</b> <span>{data.transaction_id}</span>
                </DetailsInfoRow>
                <DetailsInfoRow>
                    <b>{t("Status")}</b> <span><PaymentStatus row={data} label={true}/></span>
                </DetailsInfoRow>
                <DetailsInfoRow>
                    <b>{t("Bank Result Code")}</b> <span>{data.result_code}</span>
                </DetailsInfoRow>
                <DetailsInfoRow>
                    <b>{t("Bank Result")}</b> <span>{data.result?.description}</span>
                </DetailsInfoRow>
                <DetailsInfoRow>
                    <b>{t("Payer Card Type")}</b> <span>{data.result?.card_details?.card_type}</span>
                </DetailsInfoRow>
                <DetailsInfoRow>
                    <b>{t("Billed to card number")}</b> <span>xxxx-xxxx-xxxx-{data.result?.card_details?.last_4_digits}</span>
                </DetailsInfoRow>
                
            </DetailsInfoCard>
        </PopupMainContent>
    )
}